import React from 'react';
import styled, { useTheme } from 'styled-components/macro';
import { MdInfo } from 'react-icons/md';
import { Tooltip, Typography } from 'react-covideo-common';
import { WIDGET_TOOLTIP_CONFIG } from './WidgetTooltipConfig';
import { WidgetValues } from '../types';
import { useTranslation } from 'react-i18next';
import { Flex } from 'lib/components/styles/layout';

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
  top: 2px;
`;

type Props = {
  widgetType: WidgetValues;
  position?: 'left' | 'right' | 'top' | 'bottom';
};

export const WidgetTypeTooltip = ({ widgetType, position }: Props) => {
  const { colors } = useTheme();
  const { t } = useTranslation();
  const config = WIDGET_TOOLTIP_CONFIG[widgetType];

  if (!config) return null;

  return (
    <TooltipWrapper>
      <Tooltip
        position={position || ('left' as any)}
        hoverable={true}
        extendStyles={{
          popup: {
            padding: '12px',
            width: '320px',
            maxWidth: '90vw',
            borderRadius: '8px',
            zIndex: 999,
          },
        }}
        popup={
          <Flex gap='4px'>
            <Typography variant='normal' fontWeight={600}>
              {t('Why use this?')}
            </Typography>
            <Typography variant='normal'>{t(config.whyUse)}</Typography>

            <br />
            <Typography variant='normal' fontWeight={600}>
              {t('KPI Definitions')}
            </Typography>

            {config.kpis.map((kpi, index) => (
              <div key={index}>
                <Typography variant='normal' fontWeight={600}>
                  {t(kpi.name)}
                </Typography>
                <Typography>{t(kpi.description)}</Typography>
              </div>
            ))}
          </Flex>
        }
      >
        <MdInfo
          color={colors.neutral[40]}
          size={20}
          style={!!position ? undefined : { marginBottom: '17px' }}
        />
      </Tooltip>
    </TooltipWrapper>
  );
};
